<div
  class="section-heading-wrapper"
  [class.light]="light"
  [class.noMargin]="noMargin"
>
  <div class="left-line decorator-line"></div>
  <div class="right-line decorator-line"></div>
  <div class="top-line decorator-line"></div>
  <div class="bottom-line decorator-line"></div>
  <h1 [class.light]="light" [class.small]="small">
    <span>{{ getFirstLetter() }}</span
    >{{ getExceptFirstLetter() }}
  </h1>
</div>
